import logo from '../logo.svg';
import './App.css';
import { BannerSeguimento } from './components/BannerSeguimento';
import { HomeSeguimento } from './components/HomeSeguimento';
import { HomeTopBar } from './components/HomeTopBar';

export const App = () => {
  return (
    <div className="App">

       
        <HomeTopBar/>

        <BannerSeguimento/> 

        <HomeSeguimento/>
       

    </div>
  );
}

